import React, { useLayoutEffect, useRef } from 'react'
import './couple.css'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const Photocouple = ({details}) => {


  const sectionRef = useRef(null)

const flowerRefs = useRef([])

const addFlowerRef = (el) => {
  if (el && !flowerRefs.current.includes(el)) {
    flowerRefs.current.push(el)
  }
}

useLayoutEffect(() => {
  const ctx = gsap.context(() => {

    gsap.from(flowerRefs.current, {
      opacity: 0,
      duration: 1,
      stagger: 0.08,
      ease: "power2.out",

      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 75%",
        once: true,
      },
    })

  }, sectionRef)

  return () => ctx.revert()
}, [])


  const renderPersonCard=({
    image,
    alt,
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  })=>{
     if (!image?.url) return null;
     const baseUrl = image.url;

     return(
       <div className="single-couple-container" data-aos="fade-up"  >
        <div className="couple-grandparents">
           {grandParentsName && (
            <p>
              {grandParentsPrefix} {grandParentsName}
            </p>
          )}
           </div>
               <img src={baseUrl} 
          alt={alt} 
          srcSet={`
         ${baseUrl.replace('/upload/', '/upload/w_320/')} 320w,
          ${baseUrl.replace('/upload/', '/upload/w_640/')} 640w,
           ${baseUrl.replace('/upload/', '/upload/w_1080/')} 1080w
         `}
           sizes="(max-width: 320px) 320px,
               (max-width: 640px) 640px,
               (max-width: 1080px) 1080px"
          className='couple-image' />
         
         
          <h1 className='couple-name'>{fullname}</h1>
            <div className="couple-parents">
                       {parentsName && (
            <p>
              {parentprefix} {parentsName}
            </p>
          )}
                      </div>
      
       </div>
     )
  }

  const groomCard=()=>{
   return renderPersonCard({
     image:details?.groomImage,
      alt:"groomImage",
       fullname:details?.groomFullName || "Groom Full Name",
      parentprefix:details?.groomParentsPrefix,
      parentsName:details?.groomParents,
      grandParentsPrefix:details?.groomGrandParentsPrefix,
      grandParentsName:details?.groomGrandParents,
    }
    )
  }

   const brideCard=()=>
    renderPersonCard({
      image:details?.brideImage,
      alt:"brideImage",
      fullname:details?.brideFullName || "Bride Full Name",
      parentprefix:details?.brideParentsPrefix,
      parentsName:details?.brideParents,
      grandParentsPrefix:details?.brideGrandParentsPrefix,
      grandParentsName:details?.brideGrandParents,
    })

  return (
    <section className='couple-section photo-couple'    ref={sectionRef} >
         <img src="/couple-section-flower.png" className="corner top-left" alt='side-flower'  ref={addFlowerRef}    />
<img src="/couple-section-flower.png" className="corner top-right" alt='side-flower'  ref={addFlowerRef}   />
<img src="/couple-section-flower.png" className="corner bottom-left" alt='side-flower' ref={addFlowerRef}   />
<img src="/couple-section-flower.png" className="corner bottom-right" alt='side-flower' ref={addFlowerRef}    />
        <h1 className='couple-heading'  data-aos="fade-up" >{details?.sectionHeading} </h1>
         
          <div className="couple-wrapper">
          {details?.displayOrder==="groomFirst"?
            <> 
               {groomCard()}
                  <span className="couple-divider" data-aos="fade-up" >
            &
          </span>
          {brideCard()}
            </>
          :<>
        {brideCard()}
          <span className="couple-divider" data-aos="fade-up">
            &
          </span>
          {groomCard()}

          </>}
       </div>
    </section>
  )
}

export default Photocouple